<template>
  <div>
    <h5 class="card-title">
      <i class="fas fa-user-times"></i>
      Usuários Mencionados (Não Tratados)
    </h5>

    <div v-if="loading" class="text-center">
      <b-spinner small></b-spinner>
      <span class="ml-2">Carregando...</span>
    </div>
    <div v-else-if="allMentions.length === 0" class="text-muted text-center">
      <i class="fas fa-check-circle"></i>
      Nenhum usuário mencionado pendente de tratamento
    </div>
    <div v-else>
      <div class="mb-3">
        <div>
          <b-badge variant="warning" class="mr-2">
            Total: {{ totalMentions }}
          </b-badge>
          <small class="text-muted">usuários pendentes de tratamento</small>
        </div>
      </div>

      <div class="mentions-list-container">
        <div class="mentions-header">
          <div class="row-content">
            <div class="user-section header-label">Usuário</div>
            <div class="protocol-section header-label">Protocolo</div>
            <div class="company-section header-label">Empresa</div>
            <div class="date-section header-label">Data de Menção</div>
            <div class="status-section header-label">Status</div>
          </div>
        </div>
        <div class="mentions-scroll" @scroll="handleScroll">
          <div class="mentions-list">
            <div
              v-for="mention in visibleMentions"
              :key="mention._id"
              class="mention-row"
              @click="viewComplaint(mention)"
            >
              <div class="row-content">
                <div class="user-section">
                  <strong class="user-name">{{ mention.fullname }}</strong>
                </div>

                <div class="protocol-section">
                  <strong class="protocol-link">{{
                    mention.complaint.protocol
                  }}</strong>
                </div>

                <div class="company-section">
                  <span class="company-name">{{
                    mention.company.fantasyName
                  }}</span>
                </div>

                <div class="date-section">
                  <span class="date-text">{{
                    mention.createdAt | datetime
                  }}</span>
                </div>

                <div class="status-section">
                  <b-badge variant="danger"> BLOQUEADO </b-badge>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getMentionedUsers } from "../../../../api/charts";

export default {
  name: "MentionedUsers",
  props: {
    companyId: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      data: [],
      loading: true,
      limit: 15,
    };
  },
  computed: {
    totalMentions() {
      return this.allMentions.length;
    },
    allMentions() {
      return [...this.data].sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
      );
    },
    visibleMentions() {
      return this.allMentions.slice(0, this.limit);
    },
  },
  watch: {
    companyId() {
      this.fetchData();
    },
  },
  async created() {
    await this.fetchData();
  },
  methods: {
    async fetchData() {
      try {
        this.loading = true;
        this.limit = 15;
        const response = await getMentionedUsers(this.companyId);
        this.data = response.data;
      } catch (error) {
        console.error("Erro ao carregar usuários mencionados:", error);
        this.$bvToast.toast("Erro ao carregar usuários mencionados", {
          title: "Erro",
          toastClass: "custom-toast custom-toast-error",
          variant: "light",
          solid: true,
          autoHideDelay: 10000,
          noCloseButton: false,
        });
      } finally {
        this.loading = false;
      }
    },
    viewComplaint(mention) {
      this.$router.push(`/denuncias/${mention.complaint._id}`);
    },
    handleScroll(event) {
      const { scrollTop, clientHeight, scrollHeight } = event.target;
      if (scrollTop + clientHeight >= scrollHeight - 10) {
        if (this.limit < this.allMentions.length) {
          this.limit += 15;
        }
      }
    },
  },
};
</script>

<style scoped>
.mentions-list-container {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border: 1px solid #e9ecef;
}

.mentions-header {
  padding: 0.75rem 1rem;
  background-color: #f8f9fa;
  border-bottom: 2px solid #dee2e6;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.header-label {
  font-weight: 600;
  color: #495057;
  font-size: 0.8rem;
  text-transform: uppercase;
}

.mentions-scroll {
  max-height: 460px;
  overflow-y: auto;
}

.mentions-list {
  padding: 0;
}

.mention-row {
  border-bottom: 1px solid #f1f3f4;
  padding: 0.75rem 1rem;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.mention-row:hover {
  background-color: #f8f9fa;
}

.mention-row:last-child {
  border-bottom: none;
}

.row-content {
  display: grid;
  grid-template-columns: 2fr 1.5fr 1.5fr 1.5fr 1fr;
  align-items: center;
  gap: 1rem;
}

.user-section,
.protocol-section,
.company-section,
.date-section,
.status-section,
.actions-section {
  display: flex;
  align-items: center;
}

.actions-section {
  justify-content: center;
}

.user-name {
  color: #007bff;
  font-weight: 500;
  font-size: 0.9rem;
}

.protocol-link {
  color: #007bff;
  font-weight: 500;
}

.company-name,
.date-text {
  color: #6c757d;
  white-space: nowrap;
}

.action-icon {
  color: #6c757d;
  transition: color 0.2s;
}

.mention-row:hover .action-icon {
  color: #007bff;
}

/* Responsividade */
@media (max-width: 1200px) {
  .row-content {
    grid-template-columns: 2fr 1fr 1fr 1fr 1fr;
    gap: 0.5rem;
  }

  .user-name,
  .protocol-link {
    font-size: 0.85rem;
  }
}

@media (max-width: 768px) {
  .row-content {
    grid-template-columns: 1fr;
    gap: 0.5rem;
  }

  .user-section,
  .protocol-section,
  .company-section,
  .date-section,
  .status-section,
  .actions-section {
    justify-content: flex-start;
  }

  .actions-section {
    justify-content: center;
  }
}
</style>
